import { createChildListModalComponent } from 'factories/ChildListModal'
import { tableCellComponents } from 'helpers/listItems'

export default createChildListModalComponent({
  getStorageKey: (self) => 'sideForms.addFromFile',
  getRowClassName: (self) => (record, index) => (record.id <= 0 ? 'table-row-error' : ''),
  getRowSelectionCheckboxProps: (self) => (record) => ({ disabled: record.id <= 0 }),
  tableCellComponents,
})()
